var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container-fluid layout-without-background col-lg-9 col-sm-11 px-3"
  }, [_c('div', {
    staticClass: "text-lg-center pt-4 pb-2"
  }, [_vm.currentPayload.title.length ? _c('RegularTitle', {
    staticClass: "title",
    attrs: {
      "text": _vm.currentPayload.title[0].text,
      "level": _vm.currentPayload.title[0].type
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-wrap"
  }, _vm._l(_vm.currentPayload.reviews, function (item) {
    return _c('Review', {
      key: item.review_description,
      attrs: {
        "stars": item.stars,
        "user": item.review_user,
        "experience": item.review_experience,
        "description": item.review_description
      }
    });
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "text-center py-3"
  }, [_vm.currentPayload.button.cta ? _c('Cta', {
    staticClass: "px-5",
    attrs: {
      "target": _vm.target,
      "text-btn": _vm.currentPayload.button.cta,
      "url": _vm.currentPayload.button.url
    }
  }) : _vm._e()], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };